import React from "react";
import { Tabs, Card } from "antd";
import { FormattedMessage } from "react-intl";

import LicenseList from "../Admin/License/LicenseList";
import LicensesListCloud from "../../components/LicensesListCloud";

export default function LicenseContainer() {
  const items = [
    {
      label: <FormattedMessage id="LicenseContainer.cloudLicenses" defaultMessage="Cloud licenses" />,
      key: "cloudLicenses",
      children: <LicensesListCloud />,
    },
    {
      label: <FormattedMessage id="LicenseContainer.localLicenses" defaultMessage="Local licenses" />,
      key: "localLicenses",
      children: <LicenseList />,
    },
  ];

  return (
    <Card>
      <Tabs items={items} />
    </Card>
  );
}
